import { __makeTemplateObject } from "tslib";
import styled from "styled-components";
export var TabGroupWrapper = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: flex;\n  gap: ", ";\n  align-items: flex-end;\n"], ["\n  display: flex;\n  gap: ", ";\n  align-items: flex-end;\n"])), function (_a) {
    var theme = _a.theme;
    return theme.spacing.xs;
});
var templateObject_1;
//# sourceMappingURL=styles.js.map